import { Component, ElementRef, OnInit, inject, signal, viewChild, viewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService, InternationalizationService } from '@app/core/services';

@Component({
    selector: 'app-welcome',
    templateUrl: './welcome.component.html',
    styleUrls: ['./welcome.component.scss'],
    standalone: true
})
export class WelcomeComponent implements OnInit {
  protected gnLetter = viewChildren<ElementRef>('gnLetter');
  protected mask = viewChild<ElementRef>('mask');
  protected gamename = viewChild<ElementRef>('gamename');
  protected step = signal(0);
  protected width = signal(0);
  protected welcomeTextAnimated = signal(false);
  protected displayGameName = signal(false);
  protected showStartBtn = signal(false);

  private router = inject(Router);
  private sessionService = inject(SessionService);
  public i18n = inject(InternationalizationService);

  ngOnInit(): void {
    this.step.set(1);
    this.loadWelcomeText();
  }

  ngAfterViewInit() {
    // TOTO:  better implementation
    setTimeout(() => {
      this.mask()?.nativeElement?.classList?.add('fade-out');

      setTimeout(()=> {
        this.displayGameName.set(true);

        setTimeout(() => {
          this.gamename()?.nativeElement?.classList?.remove('fly-in');
          this.gamename()?.nativeElement?.classList?.add('animate-bg');
    
          let index = 0;    
          setTimeout(() => {
            const animate = setInterval(()=> {
              this.gnLetter()[index]?.nativeElement?.classList?.add("on");
              this.gnLetter()[index]?.nativeElement?.classList?.add("neon");
              index++;
              if(index === this.gnLetter().length) {
                setTimeout(()=> {
                  this.showStartBtn.set(true);
                }, 500);
                
                clearInterval(animate);
              }
            }, 250);
          }, 1000);
        }, 2500);
      }, 1500);
    }, 3500);
  }

  loadWelcomeText() {
    this.welcomeTextAnimated.set(true);
  }


  startGame(ev: MouseEvent) {
    ev.preventDefault();
    
    if(!this.showStartBtn()) {
      return;
    }

    // this.soundsService.setLanguagePageSrc();
    // this.soundsService.playMusic();

    const session = this.sessionService.getSession();
    
    if(this.sessionService.isUserAuthenticated()) {
      setTimeout(() => {
        if(!session.location) {
          this.router.navigate(['/select-language']);
        } else {
          this.router.navigate(['/main-menu']);
        }
      }, 500);
    } else {
      setTimeout(() => {
        if (!session?.location || (session.location && (!session.location.country || !session.location.language))) {
          this.router.navigate(['/select-language']);
        } else {
          const profilesHistory = this.sessionService.getProfilesHistory();

          // no profiles found
          if(profilesHistory.length === 0) {
            this.router.navigate(['/user-details']);
            return;
          }
  
          // go to profile page
          this.router.navigate(['/profiles']);
        }
      }, 500);
    }
  }

}
